/**
 * @name useIsAssistiveMode
 *
 * @hook
 *
 * @description
 * Detects whether the UsableNet assistive view is active by checking
 * for the `un-assistive` class on the `<html>` element.
 *
 * When this class is present, time-limited UI patterns (e.g. toast
 * notifications) should persist until the user explicitly dismisses
 * them, satisfying WCAG 2.2 SC 2.2.1 (Timing Adjustable).
 *
 * @returns {boolean} `true` when `html.un-assistive` is present.
 */
export const useIsAssistiveMode = (): boolean => {
    if (typeof document === 'undefined') return false
    return document.documentElement.classList.contains('un-assistive')
}
